export default{
    tukeExplore: {
        accountChain: '账户链',
        bussnessChain: '商业链',
        posChain: 'PoS链',
        enterTheThinkiumDAPPWebAddress: '输入Dapp网址',
        favorites: '收藏夹',
        noDappCollection: '您还没有收藏过DApp，快去收藏吧~',
        openDappAndCollect: '打开DApp，点击右上角【收藏】即可。',
        recommend: '推荐',
        Organization: '组织',
        orgDesc: '加入您的组织', 
        go:'前往',
    },
}